export default __webpack_public_path__ + "static/media/logo.a486ab47.png";